import React from 'react';
import { XCircle, AlertTriangle, Clock } from 'lucide-react';
export function ProblemAgitation() {
  return <section className="bg-white py-20 px-4 sm:px-6 border-t border-gray-100" data-id="element-107">
      <div className="max-w-4xl mx-auto" data-id="element-108">
        {/* The Problem Header */}
        <div className="text-center mb-16" data-id="element-109">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-[#1B2A4A] mb-6" data-id="element-110">
            Esto no es una guía para "buscar pisos mejor".
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-111">
            Es para dejar de perderlos por las mismas 3 razones que hacen que
            los propietarios te descarten sin pensarlo dos veces. Tu candidatura
            no se entiende, no transmite control y no empuja a decisión.
          </p>
        </div>

        {/* The Reality Check Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-112">
          <div className="bg-[#FAFAF7] p-6 rounded-xl border border-gray-100 shadow-sm" data-id="element-113">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-4" data-id="element-114">
              <Clock className="w-6 h-6 text-red-600" data-id="element-115" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-116">Velocidad Absurda</h3>
            <p className="text-gray-600 text-sm" data-id="element-117">
              Un anuncio bueno recibe 20-30 mensajes en la primera hora. Si
              tardas en enviar papeles o en responder, ya hay 5 candidatos por
              delante.
            </p>
          </div>

          <div className="bg-[#FAFAF7] p-6 rounded-xl border border-gray-100 shadow-sm" data-id="element-118">
            <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mb-4" data-id="element-119">
              <AlertTriangle className="w-6 h-6 text-orange-600" data-id="element-120" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-121">Casting, no Venta</h3>
            <p className="text-gray-600 text-sm" data-id="element-122">
              Una visita se convierte en un casting. La decisión final rara vez
              es "quién paga más" o "quién vio el piso primero".
            </p>
          </div>

          <div className="bg-[#FAFAF7] p-6 rounded-xl border border-gray-100 shadow-sm" data-id="element-123">
            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-4" data-id="element-124">
              <XCircle className="w-6 h-6 text-gray-600" data-id="element-125" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-126">
              El Filtro del Miedo
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-127">
              El propietario se pregunta: "¿A quién elijo para no complicarme la
              vida?". No busca al inquilino perfecto, busca al que le genere
              menos dudas.
            </p>
          </div>
        </div>

        {/* The Pain Points List */}
        <div className="bg-[#1B2A4A] text-white rounded-2xl p-8 md:p-12 shadow-xl relative overflow-hidden" data-id="element-128">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#C9A84C] rounded-full mix-blend-overlay filter blur-3xl opacity-10" data-id="element-129"></div>

          <h3 className="text-2xl font-serif font-bold mb-8 text-center" data-id="element-130">
            Si buscas piso en Madrid, Barcelona, Valencia o Málaga...
          </h3>

          <ul className="space-y-4 max-w-2xl mx-auto" data-id="element-131">
            <li className="flex items-start gap-4" data-id="element-132">
              <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-133" />
              <span className="text-lg text-gray-200" data-id="element-134">
                Te piden "tres nóminas, contrato, vida laboral..." y cuando lo
                envías, silencio.
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-135">
              <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-136" />
              <span className="text-lg text-gray-200" data-id="element-137">
                Te rechazan por una sola cosa (contrato reciente, autónomo,
                extranjero) sin darte opción a explicarte.
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-138">
              <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-139" />
              <span className="text-lg text-gray-200" data-id="element-140">
                Sientes que hay reglas que nadie te explica y cada semana el
                precio sube.
              </span>
            </li>
          </ul>

          <div className="mt-10 text-center" data-id="element-141">
            <p className="text-[#C9A84C] font-bold text-xl mb-2" data-id="element-142">
              No estás loco.
            </p>
            <p className="text-gray-300" data-id="element-143">
              Solo estás jugando un juego donde la presentación pesa más que la
              intención.
            </p>
          </div>
        </div>

        {/* The 30 Second Concept */}
        <div className="mt-20 text-center max-w-3xl mx-auto" data-id="element-144">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-[#1B2A4A] mb-8" data-id="element-145">
            La diferencia entre "me eligen" y "me ignoran" se decide en 30
            segundos
          </h2>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-146">
            Cuando tu caso cae en manos de una agencia o de un propietario con
            prisa, pasan dos preguntas por su cabeza:
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-6 mb-10" data-id="element-147">
            <div className="bg-[#FDF8EE] border-2 border-[#C9A84C] px-6 py-4 rounded-lg font-bold text-[#1B2A4A] shadow-sm transform -rotate-1" data-id="element-148">
              1) ¿Entiendo de dónde sale el dinero?
            </div>
            <div className="bg-[#FDF8EE] border-2 border-[#C9A84C] px-6 py-4 rounded-lg font-bold text-[#1B2A4A] shadow-sm transform rotate-1" data-id="element-149">
              2) ¿Esta persona me va a generar fricción?
            </div>
          </div>

          <p className="text-lg text-gray-700" data-id="element-150">
            Y ahí es donde mueren candidaturas perfectamente válidas. No por
            falta de solvencia. <br data-id="element-151" />
            <span className="font-bold text-[#1B2A4A]" data-id="element-152">
              Por falta de Credibilidad, Claridad y Cierre.
            </span>
          </p>
        </div>
      </div>
    </section>;
}